import script from "./FAQComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQComponent.vue?vue&type=script&setup=true&lang=js"

import "./FAQComponent.vue?vue&type=style&index=0&id=1a7106e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7106e3"]])

export default __exports__